module.exports = __webpack_public_path__ + "img/myHealthcareMarkRed.8f52041b.png";